import { render, staticRenderFns } from "./surveItem4.vue?vue&type=template&id=d8276b0c&scoped=true"
import script from "./surveItem4.vue?vue&type=script&lang=js"
export * from "./surveItem4.vue?vue&type=script&lang=js"
import style1 from "./surveItem4.vue?vue&type=style&index=1&id=d8276b0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8276b0c",
  null
  
)

export default component.exports